@if (isRoot) {
  <h1>Data Class Diagram</h1>
}
@if (dataClass) {
  <div [class]="cssClass">
    <div class="class-list__details">
      <b>{{ dataClass.name }}</b>
      @if (dataClass.fields) {
        <div class="class-list__field-details">
          <ul>
            @for (field of dataClass.fields; track field) {
              <li>
                {{ fieldText(field) }}
              </li>
            }
          </ul>
        </div>
      }
      @if (dataClass.relations) {
        <div class="class-list__relation-details">
          <ul>
            @for (relation of dataClass.relations; track relation) {
              <li>
                {{ relationText(relation) }}
              </li>
            }
          </ul>
        </div>
      }
    </div>
    <div class="class-list__children">
      @for (dataClass of childDataClasses; track dataClass) {
        <app-api-welcome [tenantCode]="tenantCode" [data]="data" [dataClass]="dataClass">
        </app-api-welcome>
      }
    </div>
  </div>
}
